module.exports = __webpack_public_path__ + "static/img/crone_weavess.1aab040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/crone_weavess.png
// module id = f6zg
// module chunks = 0